import { render, staticRenderFns } from "./UpdateOrganisationModal.vue?vue&type=template&id=eccda2b2&"
import script from "./UpdateOrganisationModal.vue?vue&type=script&lang=js&"
export * from "./UpdateOrganisationModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateOrganisationModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports